module.exports = __webpack_public_path__ + "img/logo-p.2d9d9ec1.png";